import { renderWhatsAppTemplate } from '@sauda/templates';

export interface InviteShareInput {
  inviter: string;
  agency: string;
  app: string;
  link: string;
  locale: string;
}

/** The message from the approved template registry, in the user's language when available. */
export function inviteMessage(input: InviteShareInput): string {
  return renderWhatsAppTemplate(
    'team_invite',
    { inviter: input.inviter, agency: input.agency, app: input.app, link: input.link },
    input.locale,
  );
}

/** `wa.me` share URL: the broker sends it from their own phone, so no opt-in is needed. */
export function whatsappShareUrl(input: InviteShareInput): string {
  return `https://wa.me/?text=${encodeURIComponent(inviteMessage(input))}`;
}
